export default __webpack_public_path__ + "static/media/0_C.31fc5198.svg";